import React, {useState} from 'react';
import Tr from "translations/Translations";
import ExpansionProgressPanel from "./ExpansionProgressPanel";
import RfxOfferService from "services/RfxOfferService";
import {connect} from "react-redux";
import ProgressStatus from "../../../../../../constants/ProgressStatus";
import EditSessionOnlinePopup from "./EditSessionOnlinePopup";
import {streamPlatformLabel} from "../constants/OnlinePlatforms";

const PublicSessionOnlineProgress = (
    {
        demandId,
        roundId,
        onlineSession
    }) => {

    const [editPopupOpen, setEditPopupOpen] = useState(false);

    const onUpdated = () => {
        RfxOfferService.getOffersPublicSessionOnlineStatus(roundId).then(() => {
            setEditPopupOpen(false)
        })
    }
    return (
        <>
            <ExpansionProgressPanel
                buttonText={Tr('streaming_connect')}
                title={Tr('streaming_platform_title')}
                buttonDisabled={!onlineSession.editable}
                onButtonClick={() => setEditPopupOpen(true)}
                optional={!onlineSession.required}
                progressAtlText={onlineSession.sessionOnline.platform ? Tr('streaming_connected', {platform: streamPlatformLabel(onlineSession.sessionOnline.platform)}) : Tr('streaming_not_connected')}
                progress={onlineSession.status === ProgressStatus.PROCESSED ? 100 : 0}
            />
            {editPopupOpen && <EditSessionOnlinePopup
                demandId={demandId}
                roundId={roundId}
                sessionOnlineStatus={onlineSession}
                onClose={() => setEditPopupOpen(false)}
                onUpdated={onUpdated}/>
            }
        </>
    );
};

PublicSessionOnlineProgress.propTypes = {};

const mapStateToProps = state => {
    return {
        onlineSession: state.resources[RfxOfferService.RESOURCE_ID_RFX_PUBLIC_SESSION_ONLINE_STATUS]
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PublicSessionOnlineProgress);
